import { render, staticRenderFns } from "./addStore.vue?vue&type=template&id=bfd56f5e&scoped=true&"
import script from "./addStore.vue?vue&type=script&lang=js&"
export * from "./addStore.vue?vue&type=script&lang=js&"
import style0 from "./addStore.vue?vue&type=style&index=0&id=bfd56f5e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd56f5e",
  null
  
)

export default component.exports